module.exports = __webpack_public_path__ + "img/asics.2592ea90.jpg";